import { ROUTE_TO_NEXT } from 'redux-router-kit';
import shouldRouteToStandaloneReporting from './routetoReportingMiddleware';

/**
  Route to standalone reporting via a full page refresh if all of the following are true:
   - the url starts with `/app/zap/`
   - the `mm_reporting_next_opt-in` gargoyle switch is on for the user
   - the `mm_reporting_next_opt-out` switch is off
   - this route was triggered by a link from within zapier.com, not a direct
     navigation to a browser URL (ie browser refresh, browser bookmark navigation)
*/
const routeToReportingdMiddleware = ({ getState }) => next => action => {
  if (!action || !action.type) {
    return next(action);
  }

  // `action` properties are sometimes null, not undefined, so lodash
  // get doesn't work conveniently, since it returns null instead of
  // the default value in that case. So we're not using _.get here.
  const payload = action.payload || {};
  const meta = action.meta || {};
  const url = meta.url || '';

  if (
    action.type === ROUTE_TO_NEXT &&
    url.startsWith('/app/history') &&
    shouldRouteToStandaloneReporting(getState())
  ) {
    const newPayload = { ...payload, exit: true };
    const newAction = { ...action, payload: newPayload };
    return next(newAction);
  }

  return next(action);
};

export default routeToReportingdMiddleware;
